export default __webpack_public_path__ + "static/media/kompas-logo-black-transparent.9291278d.png";